<ng-container *ngIf="document?.title">
    <div class="doc-header">
        <h1 class="doc-title">{{document.title}}</h1>
        <div class="doc-meta" *ngIf="document.create_on">
            <i class="fa fa-clock-o"></i>
            <span>{{document.create_on | date:'mediumDate'}}</span>
        </div>
    </div>
    <div class="doc-divider"></div>
    <article class="doc-body" [innerHTML]="document.content"></article>
</ng-container>

<ng-container *ngIf="!document?.title && document_uuid">
    <div class="doc-not-found">
        <i class="fa fa-exclamation-circle"></i>
        <h5>Document not found</h5>
    </div>
</ng-container>